/**
 * models
 */
import { BadgeModel } from '@sharedDirectives/badge';

/**
 * interfaces
 */
import { IUploadItemModel } from './interfaces';
import { IUploadItemDto } from '../../interfaces';

/**
 * enums
 */
import { IUploadItemStatus } from '../../enums';

/**
 * consts
 */
import { createUploadItemStatusBadge } from '../../consts';

/**
 * One uploaded file of a batch, ready to render.
 *
 * Reads through the DTO so a missing `details` block comes out as no
 * error rather than reaching the template.
 */
export class UploadItemModel implements IUploadItemModel {

    /** Built once on first read, since the badge never changes. */
    private _statusBadge: BadgeModel<IUploadItemStatus | null> | null = null;

    /**
     * @param dto - The raw item as it came off the wire.
     */
    constructor(public readonly dto: IUploadItemDto) {}

    /** @inheritdoc */
    public get id(): string {
        return this.dto?.id ?? '';
    }

    /** @inheritdoc */
    public get fileName(): string {
        return this.dto?.filename ?? '';
    }

    /** @inheritdoc */
    public get status(): string {
        return this.dto?.status ?? '';
    }

    /** @inheritdoc */
    public get errorMessage(): string | null {
        return this.dto?.details?.error ?? null;
    }

    /** @inheritdoc */
    public statusBadge(): BadgeModel<IUploadItemStatus | null> {
        this._statusBadge ??= createUploadItemStatusBadge(this.status as IUploadItemStatus);
        return this._statusBadge;
    }

}
